<template>
  <div class="capture-successfull">
    <header-capture :close="true" :back="false"></header-capture>
    <div class="capture-successfull__confeti__bg">
      <img src="@/assets/confeti.png" alt="">
    </div>
    <div class="capture-successfull__inflable__container">
      <img src="@/assets/superliga/birthday.svg" alt="" v-if="$config.MODE == 'SUPERLIGA'">
      <img src="@/assets/inflable-success.svg" alt="" v-else>
      <h3>{{$t("picture.sendPicture")}}</h3>
      <span>{{$t("picture.legend")}}</span>
      <button @click="backGame()" class="button button--white">{{$t("picture.backGame")}}</button>
    </div>
  </div>
</template>

<script>
import HeaderCapture from '@/components/Header/Picture.vue';

export default {
  components: {
    HeaderCapture
  },
  methods: {
    backGame() {
      this.$router.push(`/game/${this.$route.params.idGame}`)
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.capture-successfull {
  display: flex;
  justify-content: center;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);

  &__confeti__bg {
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    left: 0;
    top: 0;
    z-index: 0;
    background: #21012b66;
  
    img {
      position: relative;
      top: -25%;
      transition: top 3s ease;
    }
  }

  &__inflable__container {
    position: relative;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: $white;
    max-width: 280px;
    text-align: center;
    padding: $margin-xtera 0;
    
    img {
      margin-bottom: $margin-kilo;
      width: 240px;
    }

    button {
      flex-shrink: 0;
    }
  }
}
</style>